<template>
    <svg class="map-loader" viewBox="0 0 120 120">
        <circle class="map-outer-circle" cx="60" cy="60" r="50"></circle>
        <circle class="map-inner-circle" cx="60" cy="60" r="30"></circle>
    </svg>
</template>

<script>
    export default
    {
        name: 'loader',
    }
</script>
